import * as React from "react";
const YouTubeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={41} height={41} rx={4.5} fill="#FF0302" />
    <rect x={0.5} y={0.5} width={41} height={41} rx={4.5} stroke="black" />
    <g clipPath="url(#clip0_750_17831)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.8287 11.4455C36.3252 11.9452 36.6817 12.5665 36.8627 13.2473C37.5317 15.76 37.5317 21 37.5317 21C37.5317 21 37.5317 26.24 36.8627 28.7527C36.6817 29.4335 36.3252 30.0549 35.8287 30.5545C35.3322 31.0542 34.7132 31.4147 34.0336 31.6C31.5317 32.2727 21.5317 32.2727 21.5317 32.2727C21.5317 32.2727 11.5317 32.2727 9.02992 31.6C8.35031 31.4147 7.73128 31.0542 7.23479 30.5545C6.73829 30.0549 6.38175 29.4335 6.20083 28.7527C5.53174 26.24 5.53174 21 5.53174 21C5.53174 21 5.53174 15.76 6.20083 13.2473C6.38175 12.5665 6.73829 11.9452 7.23479 11.4455C7.73128 10.9458 8.35031 10.5853 9.02992 10.4C11.5317 9.72729 21.5317 9.72729 21.5317 9.72729C21.5317 9.72729 31.5317 9.72729 34.0336 10.4C34.7132 10.5853 35.3322 10.9458 35.8287 11.4455ZM26.6227 21.0001L18.259 16.2419V25.7582L26.6227 21.0001Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_750_17831">
        <rect
          width={32}
          height={32}
          fill="white"
          transform="translate(5.5 5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default YouTubeIcon;
